import en from './en';
import es from './es';
import pt from './pt';

const locale = { en, es, pt };
export const VALID_LOCALES = ['en', 'es', 'pt'];


export default locale;
